import { render, staticRenderFns } from "./scale-container.vue?vue&type=template&id=674cf490&"
import script from "./scale-container.vue?vue&type=script&lang=js&"
export * from "./scale-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports